<template>
    <div>
        <modal
        class="new-modal-default create-configure-shift-work"
        transition="nice-modal-fade"
        :name="modal_name"
        :delay="100"
        height="auto"
        :width="400"
        :adaptive="true" :scrollable="true" :clickToClose="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header-new">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title-new v-modal-title fs-20" v-if="mode == 'create'">Add Work Shift </span>
                        <span class="v-modal-dialog-title-new v-modal-title fs-20" v-if="mode == 'edit'">Edit Work Shift </span>
                    </div>
                </div>
                <div class="mb-3">
                    
                    <div>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'create'">Shift Info  </span>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'edit'">Shift Info </span>
                    </div>
                </div>

                <div class="v-modal-body">
                    <div v-if="data_loader" class="checkoutLoader">
                        <div class="LoaderPlacement">
                                <div class="digi-table-loader">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                        </div>
                    </div>
                    <div v-else class="v-modal-layout px-4 border-blue">
                        <div class="d-flex align-items-center py-3">
                            <span class=" fw-600 mr-2 fs-15 text-black" style="width: max-content;min-width: max-content;">Shift Details </span>
                            <div class="inner-line-hr w-100"></div>
                        </div>
                        <div class="row" style="margin-right: -15px;margin-left: -15px;">
                            <div class="col-lg-12 col-md-6 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-500 text-black">Shift Name <span class="text-danger">*</span></label>
                                        <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" name="shift_name" maxlength="30" v-model="shift_name" type="text" autocomplete="off" placeholder="Enter Shift Name" style="text-transform: capitalize;"/>
                                        <span class="inputBorder"></span>
                                        <div class="d-flex justify-content-between mt-2">
                                            <div class="invalid-feedback-form text-danger" style="margin-top:0 !important" v-show="errors.has('shift_name')">{{errors.first('shift_name')}}</div>
                                            <div class="text-black fs-12 text-right w-100">{{30 - shift_name.length}} / 30</div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            
                            <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group contactGroup">
                                    <span class="whiteSpace fs-14 fw-600 text-black">Start Date <span class="text-danger">*</span></span>
                                    <div class="">
                                        <div class="d-flex report-date-time-picker configure-shift align-items-center mt-3">
                                            <date-picker
                                                v-model="start_date"
                                                name="date"
                                                class="ticketdate w-100 ticketDateHeight"
                                                format="DD/MM/YYYY"
                                                type="date"
                                                lang="en"
                                                :popup-style="{ top: '100% !important' }"
                                                value-type="format"
                                                :clearable="false"
                                                @change="startDateChange($event)"
                                                :editable="false"
                                                :not-before="new Date()"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="'required'"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">Start Date is required.</span>
                                </div>
                            </div> -->
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <span class="whiteSpace fs-14 fw-500 text-black">Start Time <span class="text-danger">*</span></span>
                                    <div class="">
                                        <div class="d-flex report-date-time-picker configure-shift align-items-center workshift mt-3">
                                            <date-picker
                                                v-model="start_time"
                                                format="hh:mm A"
                                                name="start_time"
                                                class="tickettime w-100"
                                                type="time"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                placeholder="00:00:00"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="true"
                                                :minute-step="1"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="'required'"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-if="is_start_time">Start Time is required.</span>
                                </div>
                            </div>
                            <!-- <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup">
                                    <span class="whiteSpace fs-14 fw-600 text-black">End Date <span class="text-danger">*</span></span>
                                    <div class="">
                                        <div class="d-flex report-date-time-picker configure-shift align-items-center mt-3">
                                            <date-picker
                                                v-model="end_date"
                                                name="end_date"
                                                class="ticketdate w-100 ticketDateHeight"
                                                format="DD/MM/YYYY"
                                                type="date"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                :not-before="new Date(start_date_format)"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="'required'"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-if="is_end_date">End Date is required.</span>
                                </div>
                            </div> -->
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <span class="whiteSpace fs-14 fw-500 text-black">End Time <span class="text-danger">*</span></span>
                                    <div class="">
                                        <div class="d-flex report-date-time-picker configure-shift align-items-center workshift mt-3">
                                            <date-picker
                                                v-model="end_time"
                                                format="hh:mm A"
                                                name="end_time"
                                                class="tickettime w-100"
                                                type="time"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                placeholder="00:00:00"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="true"
                                                :minute-step="1"
                                                :not-before="start_time"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="'required'"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-if="is_end_time">End Time is required.</span>
                                    <span class="invalid-feedback-form text-danger" v-if="time_is_not_valid">Start Time can not be greater than End Time.</span>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-500 text-black">Total Working Hour</label>
                                        <input class="inputFieldNew inputFieldNew-padding" readonly name="total_working_hours" v-model.number="total_working_hours" type="text" autocomplete="off" placeholder="Autofill" />
                                        <span class="inputBorder"></span>
                                        <i class="icon icon-check fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 45px;"></i>
                                    </div>
                                    <!-- <span class="invalid-feedback-form text-danger" v-if="time_is_not_valid">Start Time can not be greater than End Time.</span> -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup mb-2 pt-0">
                                    <span class="whiteSpace fs-14 fw-500 text-black">Work Week <span class="text-danger">*</span></span>
                                    <div class="">
                                        <multiselect
                                            class="diginew-multiselect diginew-multiselect-dropdown arrow-down mt-3"
                                            v-model="default_text"
                                            :options="default_text_options"
                                            :searchable="false"
                                            @select="defaultSelected"
                                            :close-on-select="true"
                                            v-validate="'required'"
                                            name="default_text"
                                            :show-labels="false"
                                            placeholder="Select Default"
                                            internal-search="true"
                                        >
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('default_text')">{{errors.first('default_text')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="mt-2 mb-2 border-blue" >
                                <div  class="d-flex align-items-center py-3 px-4">
                                    <span class=" fw-600 mr-2 fs-15 text-black" style="width: max-content;min-width: max-content;">Select Week Days</span>
                                    <div class="inner-line-hr w-100"></div>
                                </div>
                            <div class="px-4">
                                <div class="table-content mb-3 new-popup-table pt-3" style="overflow-x: auto !important;">
                                    <table class="table table-content-data table-responsive create-shift-table" style=" border-radius: 6px; ">
                                        <thead >
                                            <tr style="background-color:white!important;">
                                                <th class="whiteSpace w-1 text-black fw-500 border br-lt-6px">
                                                    Monday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border">
                                                    Tuesday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border">
                                                    Wednesday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border">
                                                    Thursday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border">
                                                    Friday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border">
                                                    Saturday
                                                </th>
                                                <th class="whiteSpace w-1 text-black fw-500 border br-rt-6px">
                                                    Sunday
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold" style="background-color: #eff9fd !important;">
                                                <td colspan="8">
                                                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                </td>
                                            </tr>
                                            <tr v-if="!ajax_call_in_progress && view_data.length == 0" class="text-center font-weight-bold">
                                                <td colspan="8">No Data Found</td>
                                            </tr> -->
                                            <!-- <tr v-else v-for="ticket in view_data" :key="ticket.ticket_id"> -->
                                            <tr>
                                                <td class="whiteSpace w-1 text-center border br-lb-6px">
                                                    <el-checkbox v-model="monday" :disabled="default_text == ''" @change="selectDay($event, 'monday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border">
                                                    <el-checkbox v-model="tuesday" :disabled="default_text == ''" @change="selectDay($event, 'tuesday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border">
                                                    <el-checkbox v-model="wednesday" :disabled="default_text == ''" @change="selectDay($event, 'wednesday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border">
                                                    <el-checkbox v-model="thursday" :disabled="default_text == ''" @change="selectDay($event, 'thursday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border">
                                                    <el-checkbox v-model="friday" :disabled="default_text == ''" @change="selectDay($event, 'friday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border">
                                                    <el-checkbox v-model="saturday" :disabled="default_text != 'no'" @change="selectDay($event, 'saturday')"></el-checkbox>
                                                </td>
                                                <td class="whiteSpace w-1 text-center border br-rb-6px">
                                                    <el-checkbox v-model="sunday" :disabled="default_text != 'no'" @change="selectDay($event, 'sunday')"></el-checkbox>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    
                </div>
                <div v-if="data_loader == false" class="v-modal-dialog-actions-new">
                    <div class="d-flex justify-content-center align-items-center">
                        <button class="btn btn-danger-new btn-ssm bord-rad-18px  mr-3" :disabled="is_api_calling" @click="hideModal">Cancel</button>
                        <button class="btn btn-green-new  ml-3" style="text-transform: capitalize !important;" :disabled="is_api_calling" :class="{'text-align-left': is_api_calling}" @click="saveCreateData">
                            {{ is_api_calling ? 'Saving' : 'Save' }}
                            <half-circle-spinner v-if='is_api_calling' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { EventBus } from '../../eventBus/nav-bar-event'
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import facility_mgmt from '../../mixins/facility_mgmt.js';
import time_utils from '../../mixins/time_utils.js';
import moment from 'moment-timezone';
export default {
    props: ["modal_name", "workshift_id", "mode"],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    mixins: [facility_mgmt, time_utils],
    data() {
        return {
            data_loader: false,
            success_msg: '',
            warning_msg: '',
            search_key: '',
            days_of_workshift: [],
            default_text: "",
            default_text_options: ['no', 'yes'],
            end_time: "",
            start_date: "",
            start_date_format: '',
            end_date: "",
            shift_name: "",
            start_time: "",
            total_working_hours: 0,
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
            sunday: '',
            is_start_date: false,
            is_end_date: false,
            is_start_time: false,
            is_end_time: false,
            is_api_calling: false,
        }
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        hideModal() {
            this.$emit('hideModal')
            EventBus.$emit('ZindexChangeEnd')

        },
        // startDateChange(data) {
        //     this.start_date = data;
        //     this.start_date_format = data;
        //     this.start_date_format = this.start_date_format.split('/')[1]+'/'+this.start_date_format.split('/')[0]+'/'+this.start_date_format.split('/')[2];
        //     this.$forceUpdate();
        // },
        defaultSelected(value) {
            if(value == 'yes') {
                this.monday = true;
                this.tuesday = true;
                this.wednesday = true;
                this.thursday = true;
                this.friday = true;
                this.saturday = false;
                this.sunday = false;
                this.days_of_workshift = [];
                for(var i = 0; i < 5; i++) {
                    this.days_of_workshift.push(i);
                }
            } else {
                this.monday = false;
                this.tuesday = false;
                this.wednesday = false;
                this.thursday = false;
                this.friday = false;
                this.saturday = false;
                this.sunday = false;
                this.days_of_workshift = [];
            }
        },
        selectDay(event, day) {
            if(this.mode == 'edit') {
                switch (day) {
                    case 'monday':
                        if(event) {
                            this.days_of_workshift.push('Mon');
                        } else {
                            let index = this.days_of_workshift.indexOf('Mon');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'tuesday':
                        if(event) {
                            this.days_of_workshift.push('Tue');
                        } else {
                            let index = this.days_of_workshift.indexOf('Tue');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'wednesday':
                        if(event) {
                            this.days_of_workshift.push('Wed');
                        } else {
                            let index = this.days_of_workshift.indexOf('Wed');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'thursday':
                        if(event) {
                            this.days_of_workshift.push('Thur');
                        } else {
                            let index = this.days_of_workshift.indexOf('Thur');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'friday':
                        if(event) {
                            this.days_of_workshift.push('Fri');
                        } else {
                            let index = this.days_of_workshift.indexOf('Fri');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'saturday':
                        if(event) {
                            this.days_of_workshift.push('Sat');
                        } else {
                            let index = this.days_of_workshift.indexOf('Sat');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'sunday':
                        if(event) {
                            this.days_of_workshift.push('Sun');
                        } else {
                            let index = this.days_of_workshift.indexOf('Sun');
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                }
                this.days_of_workshift = this.days_of_workshift.sort();
            } else{
                switch (day) {
                    case 'monday':
                        if(event) {
                            this.days_of_workshift.push(0);
                        } else {
                            let index = this.days_of_workshift.indexOf(0);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'tuesday':
                        if(event) {
                            this.days_of_workshift.push(1);
                        } else {
                            let index = this.days_of_workshift.indexOf(1);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'wednesday':
                        if(event) {
                            this.days_of_workshift.push(2);
                        } else {
                            let index = this.days_of_workshift.indexOf(2);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'thursday':
                        if(event) {
                            this.days_of_workshift.push(3);
                        } else {
                            let index = this.days_of_workshift.indexOf(3);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'friday':
                        if(event) {
                            this.days_of_workshift.push(4);
                        } else {
                            let index = this.days_of_workshift.indexOf(4);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'saturday':
                        if(event) {
                            this.days_of_workshift.push(5);
                        } else {
                            let index = this.days_of_workshift.indexOf(5);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                    case 'sunday':
                        if(event) {
                            this.days_of_workshift.push(6);
                        } else {
                            let index = this.days_of_workshift.indexOf(6);
                            this.days_of_workshift.splice(index, 1);
                        }
                        break;
                }
                this.days_of_workshift = this.days_of_workshift.sort();
            }
        },
        async saveCreateData() {
            // EventBus.$emit('ZindexChangeEnd')
            this.$validator.validateAll().then(async result => {
                if (result && this.start_time && this.end_time && !this.time_is_not_valid) {
                    this.saveSuccess();
                } else {
                    if(this.time_is_not_valid) {
                        this.warning_msg = "Start Time can not be greater than End Time.";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    } else {
                        this.warning_msg = "Please fill all the required fields";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                    if(this.start_time == '' || this.start_time == null || this.start_time == undefined) {
                        this.is_start_time = true;
                    }
                    if(this.end_time == '' || this.end_time == null || this.end_time == undefined) {
                        this.is_end_time = true;
                    }
                    // if(this.start_date == '' || this.start_date == null || this.start_date == undefined) {
                    //     this.is_start_date = true;
                    // }
                    // if(this.end_date == '' || this.end_date == null || this.end_date == undefined) {
                    //     this.is_end_date = true;
                    // }
                }
            });
        },
        async saveSuccess() {
            this.is_api_calling = true;
            try {
                let response;
                if(this.mode == 'create') {
                    response = await this.createWorkShift(this.create_data)
                } else {
                    this.days_of_workshift.forEach((el, index) => {
                        switch (el) {
                            case 'Mon':
                                this.days_of_workshift[index] = 0;
                                break;
                            case 'Tue':
                                this.days_of_workshift[index] = 1;
                                break;
                            case 'Wed':
                                this.days_of_workshift[index] = 2;
                                break;
                            case 'Thur':
                                this.days_of_workshift[index] = 3;
                                break;
                            case 'Fri':
                                this.days_of_workshift[index] = 4;
                                break;
                            case 'Sat':
                                this.days_of_workshift[index] = 5;
                                break;
                            case 'Sun':
                                this.days_of_workshift[index] = 6;
                                break;
                        }
                    });
                    this.create_data.workshift_id = this.workshift_id;
                    response = await this.editWorkShift(this.create_data)
                }
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('hideModal')
                    this.$emit('saveSuccess')
                }, 3000);
            }
            catch (error) {
                this.is_api_calling = false;
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
        async getWorkShiftData(id) {
            this.data_loader = true
            try {
                let params = {
                    workshift_id: id
                };
                let response = await this.getWorkShiftById(params);
                this.days_of_workshift = response.response.days_of_workshift;
                this.default_text = response.response.default;
                this.end_time = this.convertTime24To12(response.response.end_time);
                this.start_time = this.convertTime24To12(response.response.start_time);
                // this.end_date = response.response.end_date.replace(/-/g, '/');
                // this.start_date = response.response.start_date.replace(/-/g, '/');
                this.shift_name = response.response.shift_name;
                this.total_working_hours = response.response.total_working_hours;
                this.days_of_workshift.forEach((el, index) => {
                    switch (el) {
                        case 'Mon':
                            this.monday = true;
                            break;
                        case 'Tue':
                            this.tuesday = true;
                            break;
                        case 'Wed':
                            this.wednesday = true;
                            break;
                        case 'Thur':
                            this.thursday = true;
                            break;
                        case 'Fri':
                            this.friday = true;
                            break;
                        case 'Sat':
                            this.saturday = true;
                            break;
                        case 'Sun':
                            this.sunday = true;
                            break;
                    }
                });
                this.data_loader = false
            }
            catch (error) {
                this.data_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.mode == 'edit') {
                this.getWorkShiftData(this.workshift_id);
            }
        }, 500);
    },
    watch: {
        // "start_date": function(val) {
        //     if(val !== '') {
        //         this.is_start_date = false;
        //         if(this.end_date == '') {
        //             this.is_end_date = true;
        //         } else {
        //             this.is_end_date = false;
        //             let new_start_date = this.start_date;
        //             let new_end_date = this.end_date;
        //             let start_time = this.start_time ? this.convertTime12to24WithoutSec(this.start_time) : '';
        //             let end_time = this.end_time ? this.convertTime12to24WithoutSec(this.end_time) : '';
        //             this.total_working_hours = this.convertHMSFromDateAndTime(new_start_date, new_end_date, start_time, end_time);
        //         }
        //     }
        // },
        // "end_date": function(val) {
        //     if(val !== '') {
        //         this.is_end_date = false;
        //         if(this.start_date == '') {
        //             this.is_start_date = true;
        //         } else {
        //             this.is_start_date = false;
        //             let new_start_date = this.start_date;
        //             let new_end_date = this.end_date;
        //             let start_time = this.start_time ? this.convertTime12to24WithoutSec(this.start_time) : '';
        //             let end_time = this.end_time ? this.convertTime12to24WithoutSec(this.end_time) : '';
        //             this.total_working_hours = this.convertHMSFromDateAndTime(new_start_date, new_end_date, start_time, end_time);
        //         }
        //     }
        // },
        "start_time": function(val) {
            if(val !== '') {
                this.is_start_time = false;
                if(this.end_time == '') {
                    this.is_end_time = true;
                } else {
                    this.is_end_time = false;
                    let new_start_date = '';
                    let new_end_date = '';
                    this.total_working_hours = this.convertHMSFromDateAndTime(new_start_date, new_end_date, this.start_time, this.end_time);
                }
            }
        },
        "end_time": function(val) {
            if(val !== '') {
                this.is_end_time = false;
                if(this.start_time == '') {
                    this.is_start_time = true;
                } else {
                    this.is_start_time = false;
                    let new_start_date = '';
                    let new_end_date = '';
                    this.total_working_hours = this.convertHMSFromDateAndTime(new_start_date, new_end_date, this.start_time, this.end_time);
                }
            }
        },
        'total_working_hours': function(val) {
            if(val < 0) {
                this.time_is_not_valid = true;
            } else {
                this.time_is_not_valid = false;
            }
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        create_data() {
            return {
                days_of_workshift: this.days_of_workshift,
                // start_date: this.start_date.replace(/\//g, '-'),
                // end_date: this.end_date.replace(/\//g, '-'),
                end_time: this.convertTime12to24WithoutSec(this.end_time),
                shift_name: this.shift_name,
                start_time: this.convertTime12to24WithoutSec(this.start_time),
                total_working_hours: this.total_working_hours,
                default: this.default_text,
            };
        },
    },
    created() {
        const dict = {
            custom: {
                shift_name:{
                    required:() => "Shift Name is required"
                },
                default_text:{
                    required:() => "Default is required"
                },
            }
        }
        this.$validator.localize('en', dict)
    }
}
</script>
<style scoped>
.btn-green-new{
    color: #fff !important;
    background-color: #388e3c !important;
}
.table-content-data tr th {
    text-transform: capitalize;
    color: #00448b;
    background-color: white !important;
}
.border{
    border: solid 0.3px #130e0e !important;
}
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 2px 15px 11px 7px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}

    .form-group, .form-check {
        will-change: unset !important;
    }
    .text-align-left{
        text-align: left !important;
    }
    .checkoutLoader{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>